const styles = {
  fabContainer: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
  badge: {
    zIndex: 1,
  },
  card: {
    flex: 1,
  },
  grid: {
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
  },
};

export default styles;
